import React from 'react';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootBody: {
    minWidth: 335,
    marginBottom: 10,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  cardTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: theme.typography.fontFamily,
    padding: '6px 16px 5px 16px',
  },
  cardHeader: {
    fontSize: 20,
    lineHeight: '28px',
    color: theme.palette.pink,
    textTransform: 'capitalize',
  },
  cardSubHeader: {
    fontSize: 14,
    color: theme.palette.textColor2,
    fontFamily: 'Arial',
  },
  controls: {
    textAlign: 'right',
    marginRight: 9,
    [theme.breakpoints.down('xs')]: {
      marginRight: -6,
    },
  },
}));

const ContentPage = (props) => {
  const classes = useStyles();
  return (
    <Card className={classes.rootBody}>
      <div className={classes.cardTitle}>
        {/*<div className={classes.cardHeader}>{props.header.title}</div>*/}
        <div>
          <div className={classes.cardHeader}>{props.header.title}</div>
          <div className={classes.cardSubHeader}>
            {props.header.description}
          </div>
        </div>
        <div className={classes.controls}>{props.header.controls}</div>
      </div>
      <Divider />
      <CardContent id="main-content-body" style={{ padding: 0 }}>
        {props.body}
      </CardContent>
    </Card>
  );
};

export default ContentPage;
